export default "__VITE_ASSET__BCwUEOk5__"